import { useQuery } from '@tanstack/react-query';

import { usePasswordProtectedQueries } from '@app-velocity/modules/password-sharing';

export const useFetchScenarioPage = (shareToken: string | null, type: 'testing' | 'report') => {
  const { getSharedScenarioPage } = usePasswordProtectedQueries();

  const fetchPage = async (pageId: string) => {
    if (!shareToken) return;

    return getSharedScenarioPage(shareToken, pageId, type);
  };

  return fetchPage;
};

export const useGetSharedScenarioPage = (
  shareToken: string | null,
  pageId: string | null,
  type: 'testing' | 'report'
) => {
  const fetchPage = useFetchScenarioPage(shareToken, type);

  return useQuery({
    queryKey: ['scenario-page', shareToken, pageId],
    staleTime: 300000,
    queryFn: async () => {
      if (!shareToken || !pageId) return null;

      const data = await fetchPage(pageId);

      return data;
    },
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });
};
